<template>
  <div>
    <p
      v-if="! faq.portal_enabled"
      class="body-1"
    >
      {{ $t('FAQ Portal is not enabled, you can') }},
      <inertia-link :href="route('faq-settings.portal', [faq.id])">
        {{ $t('enable it here') }}
      </inertia-link>
    </p>
    <div v-else>
      <p class="body-1 mb-2">
        {{ $t('This is the URL to your FAQ Portal') }}
      </p>
      <p class="body-1">
        <a :href="faq.portal_url">{{ faq.portal_url }}</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    faq: {
      type: Object,
      required: true,
    }
  }
}
</script>